export var DEFAULT_LOCALE = 'ru';
export var SUPPORTED_LOCALES = ['ru', 'uk'];
export var getLocaleUrlCode = function getLocaleUrlCode(locale) {
  if (locale.toLowerCase() === 'uk') {
    return 'ua';
  }

  return locale.toLowerCase();
};
export var getLocaleUrlPath = function getLocaleUrlPath(locale) {
  if (locale.toLowerCase() === 'ru') {
    return '';
  }

  return "/".concat(getLocaleUrlCode(locale));
};
export var getLocaleInDBFormat = function getLocaleInDBFormat(locale) {
  if (!locale) {
    return 'ru';
  }

  if (locale === 'ua') {
    return 'uk';
  }

  return locale;
};
export var getLocaleISOCode = function getLocaleISOCode(locale) {
  if (locale) {
    return "".concat(locale, "-UA");
  }

  return "ru-UA";
};